import { render, staticRenderFns } from "./VNews.vue?vue&type=template&id=6317ef24&"
import script from "./VNews.vue?vue&type=script&lang=js&"
export * from "./VNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6317ef24')) {
      api.createRecord('6317ef24', component.options)
    } else {
      api.reload('6317ef24', component.options)
    }
    module.hot.accept("./VNews.vue?vue&type=template&id=6317ef24&", function () {
      api.rerender('6317ef24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VNews/VNews.vue"
export default component.exports